

export const GET_PRODUCT_TYPES= 'GET_PRODUCT_TYPES'
export const GET_PRODUCT_TYPES_SUCCESS= 'GET_PRODUCT_TYPES_SUCCESS'
export const GET_PRODUCT_TYPES_ERROR='GET_PRODUCT_TYPES_ERROR'

export const GET_PRODUCT_TYPE= 'GET_PRODUCT_TYPE'
export const GET_PRODUCT_TYPE_SUCCESS= 'GET_PRODUCT_TYPE_SUCCESS'
export const GET_PRODUCT_TYPE_ERROR= 'GET_PRODUCT_TYPE_ERROR'

export const ADD_PRODUCT_TYPE='ADD_PRODUCT_TYPE'
export const ADD_PRODUCT_TYPE_SUCCESS= 'ADD_PRODUCT_TYPE_SUCCESS'
export const ADD_PRODUCT_TYPE_ERROR= 'ADD_PRODUCT_TYPE_ERROR'

export const DELETE_PRODUCT_TYPE='DELETE_PRODUCT_TYPE'
export const DELETE_PRODUCT_TYPE_SUCCESS= 'DELETE_PRODUCT_TYPE_SUCCESS'
export const DELETE_PRODUCT_TYPE_ERROR= 'DELETE_PRODUCT_TYPE_ERROR'

export const UNDELETE_PRODUCT_TYPE='UNDELETE_PRODUCT_TYPE'
export const UNDELETE_PRODUCT_TYPE_SUCCESS= 'UNDELETE_PRODUCT_TYPE_SUCCESS'
export const UNDELETE_PRODUCT_TYPE_ERROR='DELETE_PRODUCT_TYPE_ERROR'

export const UPDATE_PRODUCT_TYPE='UPDATE_PRODUCT_TYPE'
export const UPDATE_PRODUCT_TYPE_SUCCESS= 'UPDATE_PRODUCT_TYPE_SUCCESS'
export const UPDATE_PRODUCT_TYPE_ERROR= 'UPDATE_PRODUCT_TYPE_ERROR'


export const REORDER_PRODUCT_TYPES='REORDER_PRODUCT_TYPES'
export const REORDER_PRODUCT_TYPES_SUCCESS= 'REORDER_PRODUCT_TYPES_SUCCESS'
export const REORDER_PRODUCT_TYPES_ERROR= 'REORDER_PRODUCT_TYPES_ERROR'



export const GetProductTypes= (data) => ({
    type: GET_PRODUCT_TYPES,
    payload: data
});

export const GetProductType= (data) => ({
    type: GET_PRODUCT_TYPE,
    payload: data
});

export const AddProductType= (data) => ({
    type: ADD_PRODUCT_TYPE,
    payload: data
});

export const DeleteProductType= (data) => ({
    type: DELETE_PRODUCT_TYPE,
    payload: data
});

export const UnDeleteProductType= (data) => ({
    type: UNDELETE_PRODUCT_TYPE,
    payload: data
});


export const UpdateProductType= (data) => ({
    type: UPDATE_PRODUCT_TYPE,
    payload: data
});

export const ReOrderProductTypes= (data) => ({
    type: REORDER_PRODUCT_TYPES,
    payload: data
});